<template>
  <!-- 一块设置项集合 -->
  <el-collapse v-model="activeNames">
    <el-collapse-item name="1" :title="title">
      <div v-for="(item, index) in settings" :key="index" class="setting-item" v-if="enable(item)">
        <basic-setting
          v-if="typeof item === 'string' || (item.type === 'basic' && enable(item))"
          :config="typeof item === 'string' ? item : item.name"
        />
        <status-setting v-else-if="item.type === 'status' && enable(item)" :statusSettings="item.statusSettings" :showTitle="item.showTitle" />
        <sub-collapse-setting v-else-if="item.type === 'subCollapse' && enable(item)" :settings="item.settings" :title="item.title" :tips="item.tips" />
        <block-setting v-else-if="item.type === 'block' && enable(item)" :settings="item.settings" />
      </div>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
import blockSetting from "./block-setting.vue"; 
import basicSetting from "./basic-setting.vue"
import subCollapseSetting from "./sub-collapse-setting.vue";
export default {
  inject: ['configData', 'configs', 'mergedConfigData'],
  components: {
    basicSetting,
    blockSetting,
    subCollapseSetting,
    statusSetting: () => import('./status-setting.vue')
  },
  props: {
    initStatus: {
      type: String,
      default: 'opened'
    },
    settings: Array,
    title: String,
    tips: [String, Object]
  },
  data() {
    return {
      activeNames: this.initStatus === 'closed' ? [] : ['1']
    }
  },
  computed: {
    enable() {
      return (config) => {
        if (config?.enable) {
          return config.enable(this.mergedBasicConfigData)
        }
        return true
      }
    },
    basicConfigData() {
      return this.configData()
    },
    mergedBasicConfigData() {
      return this.mergedConfigData()
    }
  }
  
}
</script>
<style>
.setting-item:not(:first-child) {
  margin-top: 12px;
}
.block-setting {
  padding: 12px;
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background: rgba(251, 252, 253, 1);
}

</style>